<template lang="pug">
div          
        v-row
            v-spacer       
            v-col( cols="2" sm="12" md="2")
                    v-btn(color="primary" @click="sendSearch()" block large)   
                        v-icon.fa.fa-refresh  
        v-row    
            v-col( cols="12" sm="12" md="12")
                    v-data-table(
                        :headers="tableHeader"
                        :items="tableFilteredInfo"
                        class="elevation-2"
                        :loading="!tableFilteredInfo.length"
                        height="400"
                        fixed-header 
                        hide-default-header
                      ) 
                      template(  v-slot:header="{ props }") 
                          th(v-for="(column,index) in props.headers" :key="index")
                            v-autocomplete( 
                                        v-if="column.value!='Details'"
                                          :items="columnValueList(column.value)"
                                          hide-details="auto"
                                          v-model="filters[column.value]"
                                          clearable
                                          dense
                                          :label="column.text"
                                          outlined) 
                      template( v-slot:item.Details="{ item }")
                        td 
                            v-icon.fa.fa-file-text(elevation="10" color="warning" @click="sendSearch(item)")  
                                            


</template>
<script> 
export default {
    props:{
        tablaInfo:Array,
        parameter:Object
    }, 
    data(){
        return{
            ItemValues:[
                        {value:0, text:'Activa'},
                        {value:1, text:'Inactiva'},
                        {value:2, text:'Todos'}
                    ],
            tableHeader:[
                        {text:'Usuario',value:'NameUser'},
                        {text:'Documento',value:'NameDocType'},
                        {text:'Periodo',value:'Period'},
                        {text:'Cantidad Categorias',value:'Quantity_Category'},
                        {text:'Detalle',value:'Details'},
                        ],
            filters:{}
        }
    },
    computed:{
        tableFilteredInfo() {
            return this.tablaInfo.filter(d => {
            return Object.keys(this.filters).every(f => {
                if(this.filters[f]==null)
                return true
                else{
                console.log(this.filters[f])
                console.log(d[f])
                return this.filters[f].toString().length < 1 || this.filters[f].toString().includes(d[f].toString())
                }

            })
            })
      }
    },
    methods:{ 
            columnValueList(val) {
                return this.tableFilteredInfo.map(d => d[val])
            },
            sendSearch(item){  
                this.$emit("update:parameter",this.parameter) 
                this.$emit("sendSearch",item) 
            }, 
            sendRefresh(){ 
                this.$emit("update:parameter",this.parameter) 
                this.$emit("sendRefresh",this.parameter) 
            },  
    }
}
</script>
<style>
    .table-fade-enter-active {
      transition: all .5s ease;
    }
    .table-fade-leave-active {
      transition: all .5s ease;
    }
    .table-fade-enter, .table-fade-leave-to{
      transform: translateY(-20px);
      opacity: 0;
    } 
</style>